<template>
<div class="col-lg-3 col-4 mb-2">
    <div class="crop__container">
        <div class="crop__container__circle">
            <a @click="selectCrop">
            <div class="crop__container__circle__cover" :class="[selected ? 'bg__primary' : 'bg__secondary']">
                <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="selected">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M15.2559 0.410749C15.5814 0.736186 15.5814 1.26382 15.2559 1.58926L6.08926 10.7559C5.76382 11.0814 5.23618 11.0814 4.91074 10.7559L0.744078 6.58926C0.418641 6.26382 0.418641 5.73619 0.744078 5.41075C1.06951 5.08531 1.59715 5.08531 1.92259 5.41075L5.5 8.98816L14.0774 0.410749C14.4028 0.0853125 14.9305 0.0853125 15.2559 0.410749Z"
                        fill="#FFFCF9" />
                </svg>

                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-else>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M9.99999 3.33333C10.4602 3.33333 10.8333 3.70642 10.8333 4.16666V15.8333C10.8333 16.2936 10.4602 16.6667 9.99999 16.6667C9.53975 16.6667 9.16666 16.2936 9.16666 15.8333V4.16666C9.16666 3.70642 9.53975 3.33333 9.99999 3.33333Z"
                        fill="#E5E5E5" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M3.33334 10C3.33334 9.53977 3.70644 9.16667 4.16668 9.16667H15.8333C16.2936 9.16667 16.6667 9.53977 16.6667 10C16.6667 10.4602 16.2936 10.8333 15.8333 10.8333H4.16668C3.70644 10.8333 3.33334 10.4602 3.33334 10Z"
                        fill="#E5E5E5" />
                </svg>
        
            </div>
            </a>
        </div>
        <div class="crop__container__name">{{crop.name}}</div>
    </div>
</div>
</template>

<script>
export default {
    props:['crop'],
    data() {
        return {
            selected: false
        }
    },
    methods: {
        selectCrop() {
            
                this.$emit('selectedCrop', this.crop)
                this.selected = !this.selected;
            
            
        }
    }
}
</script>

<style>

</style>